






























import { Prop, Vue, Watch } from "vue-property-decorator";
import Component from "vue-class-component";
import { IPatch } from "@/types";

@Component
export default class Patches extends Vue {
  @Prop({ required: true, type: Boolean }) filterFeatured!: boolean;
  private patches: IPatch[] = [];

  private mounted() {
    this.fetchPatches();
  }

  private getPatchImage(patch: IPatch) {
    return `https://permafield-file-store.ams3.digitaloceanspaces.com/results/${patch.id}.png`;
  }

  @Watch("filterFeatured")
  private fetchPatches() {
    const url = this.filterFeatured
      ? "/api/patches?filter[is_featured]=true"
      : "/api/patches";
    this.patches = [];
    fetch(url).then(async (response) => {
      if (response.ok) {
        this.patches = (await response.json())["data"];
      } else {
        alert(await response.text());
      }
    });
  }
}
